import { render, staticRenderFns } from "./MmdPaperDemoCatDog.vue?vue&type=template&id=0713d277&scoped=true"
import script from "./MmdPaperDemoCatDog.vue?vue&type=script&lang=js"
export * from "./MmdPaperDemoCatDog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0713d277",
  null
  
)

export default component.exports